import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'frame-content',
    template: `
        <ng-content></ng-content>
    `
})

export class FrameContentComponent implements OnInit {
    constructor() { }

    ngOnInit() { }
}